export enum formatTypes {
  TitleCase = 'TitleCase',
  Default = 'Default',
  DefaultWithZero = 'DefaultWithZero',
  FormatAsPercentageRounded = 'FormatAsPercentageRounded',
  FormatAsCurrencyRounded = 'FormatAsCurrencyRounded',
  FormatAsPercentage = 'FormatAsPercentage',
  FormatAsCurrency = 'FormatAsCurrency',
  FormatAsCurrencyUptoTwoDecimals = 'FormatAsCurrencyUptoTwoDecimals',
  FormatAsNumber = 'FormatAsNumber',
  FormatUptoTwoDecimals = 'FormatUptoTwoDecimals',
  UptoTwoDecimals = 'UptoTwoDecimals',
  FormatNumberToShortAmount = 'FormatNumberToShortAmount',
  FormatPhone = 'FormatPhone',
  ColorsByValues = 'ColorsByValues',
}

export enum chartTypes {
  BarChart = 'BarChart',
  LineChart = 'LineChart',
  Table = 'Table',
  DynamicTable = 'DynamicTable',
  PieChart = 'PieChart',
  Summary = 'Summary',
}
